namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoItemExemptForm {
        PmId: Serenity.StringEditor;
        PmType: Serenity.IntegerEditor;
        PmGroupId: Serenity.StringEditor;
        PmExtCode: Serenity.StringEditor;
        PmDesc: Serenity.StringEditor;
        ItemType: Serenity.RadioButtonEditor;
        ListFg: Serenity.IntegerEditor;
        PluCode: Serenity.LookupEditor;
        StyleCode: Serenity.LookupEditor;
        BrandCode: Serenity.LookupEditor;
        CatCode: Serenity.LookupEditor;
        SubCat1Code: Serenity.LookupEditor;
        SubCat2Code: Serenity.LookupEditor;
        SupplCode: Serenity.LookupEditor;
    }

    export class PsAdvPromoItemExemptForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoItemExempt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoItemExemptForm.init)  {
                PsAdvPromoItemExemptForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.RadioButtonEditor;
                var w3 = s.LookupEditor;

                Q.initFormType(PsAdvPromoItemExemptForm, [
                    'PmId', w0,
                    'PmType', w1,
                    'PmGroupId', w0,
                    'PmExtCode', w0,
                    'PmDesc', w0,
                    'ItemType', w2,
                    'ListFg', w1,
                    'PluCode', w3,
                    'StyleCode', w3,
                    'BrandCode', w3,
                    'CatCode', w3,
                    'SubCat1Code', w3,
                    'SubCat2Code', w3,
                    'SupplCode', w3
                ]);
            }
        }
    }
}
